export default __webpack_public_path__ + "static/media/instagramDeskFill.a70a9e23.svg";